/* ============================================================
   NIDELYA — GSAP homepage (scroll reveal uniquement)
   Chargé après gsap.min.js + ScrollTrigger.min.js (defer, en ordre)
   Le carousel est géré par Swiper (voir nidelya-carousel.liquid)
   ============================================================ */
(function () {

  gsap.registerPlugin(ScrollTrigger);

  /* ══════════════════════════════════════════════════════════════
     SCROLL REVEAL — éléments génériques
  ══════════════════════════════════════════════════════════════ */
  gsap.utils.toArray('.np-reveal').filter(function (el) {
    return !el.classList.contains('np-bcard') && !el.classList.contains('np-product-card');
  }).forEach(function (el) {
    var delay = parseFloat(el.style.getPropertyValue('--delay')) || 0;
    gsap.set(el, { opacity: 0, y: 38 });
    gsap.to(el, {
      opacity: 1, y: 0, duration: 0.9, delay: delay, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
  });

  /* ── Bento ── */
  var bentoCards = gsap.utils.toArray('.np-bcard');
  if (bentoCards.length) {
    gsap.set(bentoCards, { opacity: 0, y: 52, scale: 0.96 });
    ScrollTrigger.create({
      trigger: '.np-bento', start: 'top 82%', once: true,
      onEnter: function () {
        gsap.to(bentoCards, { opacity: 1, y: 0, scale: 1, duration: 0.82, stagger: 0.13, ease: 'power3.out' });
      }
    });
  }

  /* ── Products ── */
  var productCards = gsap.utils.toArray('.np-product-card');
  if (productCards.length) {
    gsap.set(productCards, { opacity: 0, y: 48 });
    ScrollTrigger.create({
      trigger: '.np-products', start: 'top 85%', once: true,
      onEnter: function () {
        gsap.to(productCards, { opacity: 1, y: 0, duration: 0.8, stagger: 0.11, ease: 'power3.out' });
      }
    });
  }

  /* ── Manifeste ── */
  var manifestoTitle = document.querySelector('.np-manifesto__title');
  if (manifestoTitle) {
    gsap.set(manifestoTitle, { opacity: 0, y: 40, skewY: 2 });
    ScrollTrigger.create({
      trigger: manifestoTitle, start: 'top 85%', once: true,
      onEnter: function () {
        gsap.to(manifestoTitle, { opacity: 1, y: 0, skewY: 0, duration: 1.15, ease: 'power4.out' });
      }
    });
  }

  /* ── Glass panel ── */
  var glassPanel = document.querySelector('.np-feature-glass__panel');
  if (glassPanel) {
    gsap.set(glassPanel, { opacity: 0, x: 70 });
    ScrollTrigger.create({
      trigger: glassPanel, start: 'top 80%', once: true,
      onEnter: function () {
        gsap.to(glassPanel, { opacity: 1, x: 0, duration: 1.1, ease: 'power3.out' });
      }
    });
  }

  /* ── Feature parallax ── */
  document.querySelectorAll('.np-feature__media').forEach(function (wrap) {
    var feature = wrap.closest('.np-feature');
    if (!feature) return;
    gsap.fromTo(wrap,
      { yPercent: -2.5 },
      { yPercent: 2.5, ease: 'none',
        scrollTrigger: { trigger: feature, start: 'top bottom', end: 'bottom top', scrub: 2.5 }
      }
    );
  });

  /* ── Claim hero ── */
  var claim = document.querySelector('.np-claim');
  if (claim) {
    var tl = gsap.timeline({ delay: 0.25 });
    ['.np-eyebrow', '.np-claim__title', '.np-claim__body', '.np-claim__actions'].forEach(function (sel, i) {
      var el = claim.querySelector(sel);
      if (!el) return;
      gsap.set(el, { opacity: 0, y: 30 });
      tl.to(el, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, i * 0.12);
    });
  }

})();
